import { createContext } from 'react';
// import Plausible from 'plausible-tracker';

import { TrackingEvent } from './Tracking.events';

export const LOCATION_CHANNEL_KEY = 'location';

export const TrackingContext = createContext<ContextProps>({
	gtag: null,
	gtm: null,
	metaPixel: null,
	history: [],
	setHistory: () => {},
	locationChannel: new BroadcastChannel(LOCATION_CHANNEL_KEY),
	matomo: null,
	sendEvent: () => {},
});

interface ContextProps {
	gtag?: any;
	gtm?: any;
	plausible?: any;
	location?: Location;
	history: Array<string>;
	setHistory: any;
	locationChannel: BroadcastChannel;
	matomo?: any;
	metaPixel?: any;
	sendEvent: (event: TrackingEvent) => void;
}
